import { useNavigate } from "react-router-dom";

// Deliberately small and quiet — it's for staff, and the page behind it is
// gated by a real staff login, so a curious client tap costs nothing.
export default function SettingsGear() {
  const navigate = useNavigate();

  return (
    <a
      className="position-fixed bottom-0 start-0 text-muted opacity-25 d-inline-flex align-items-center justify-content-center"
      id="settings-gear"
      style={{
        width: 80,
        height: 80,
        fontSize: 26,
        cursor: "pointer",
        zIndex: 900,
      }}
      data-testid="settings-gear-btn"
      aria-label="Check-in settings"
      onClick={() => navigate("./settings")}
    >
      <i className="bi bi-gear"></i>
    </a>
  );
}
